import * as React from "react";
import HwArrowOn from "../../../../assets/images/hw_arrow_on.png"
import HwArrowOff from "../../../../assets/images/hw_arrow_off.png"

const NavigationButton = ({ direction, disabled = false, onClick }) => {
    const baseClasses = `flex gap-3 justify-center items-center self-stretch px-2 my-auto`;
    const rotation = direction === "prev" ? "rotate-[3.141592653589793rad]" : "";

    return (
        <button
            className={`${baseClasses}`}
            disabled={disabled}
            tabIndex={0}
            onClick={onClick}
        >
            <div className="flex gap-1 justify-center items-center self-stretch px-1 py-0.5 my-auto ">
                <img
                    loading="lazy"
                    src={`${disabled ? HwArrowOff : HwArrowOn}`}
                    alt="arrow"
                    className={`object-contain self-stretch my-auto w-[44px]  ${rotation}`}
                />
            </div>
        </button>
    );
}

export default NavigationButton;